import Calculator from './components/Calculator';
import Quotes from './components/Quotes';

function App() {
  return (
    <div className="App">
      <Calculator />
      <Quotes />
    </div>
  );
}

export default App;
